class CartCollapsibleFooter extends HTMLElement {
  constructor() {
    super();
    this.toggleHeader = null;
  }

  connectedCallback() {
    this.init();
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  init() {
    this.toggleHeader = this.querySelector('.footer-toggle-header');
    this.#syncPanelAccessibility();
  }

  #syncPanelAccessibility() {
    const panel = this.querySelector('.collapsible-content');
    if (!panel) return;

    const expanded = this.getAttribute('aria-expanded') === 'true';
    panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    panel.setAttribute('tabindex', expanded ? '0' : '-1');
  }

  bindEvents() {
    if (!this.toggleHeader) return;

    this._onToggle = this.toggle.bind(this);
    this._onKeyDown = this.handleKeyDown.bind(this);
    this._onCartUpdate = this.handleCartUpdate.bind(this);

    this.toggleHeader.addEventListener('click', this._onToggle);
    this.toggleHeader.addEventListener('keydown', this._onKeyDown);
    document.addEventListener('cart:updated', this._onCartUpdate);
  }

  unbindEvents() {
    if (this.toggleHeader) {
      this.toggleHeader.removeEventListener('click', this._onToggle);
      this.toggleHeader.removeEventListener('keydown', this._onKeyDown);
    }
    document.removeEventListener('cart:updated', this._onCartUpdate);
  }

  toggle() {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    const newState = !isExpanded;
    
    this.setAttribute('aria-expanded', newState);
    this.toggleHeader.setAttribute('aria-expanded', newState);
    this.#syncPanelAccessibility();
    
    const panel = this.querySelector('.collapsible-content');
    if (newState && panel) panel.focus();
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggle();
    }
  }

  handleCartUpdate() {
    // Refresh header element reference if it was replaced by AJAX
    this.init();
  }
}

if (!customElements.get('cart-collapsible-footer')) {
  customElements.define('cart-collapsible-footer', CartCollapsibleFooter);
}
